/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, getter-return, no-restricted-properties */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import PageType from '@linc-technologies/linced-common/enums/page-type';
import { postTemplateTinyMCEConfig } from '@linc-technologies/linced-common/utils/tinymce';

export default class EditDialog extends Component {
  @action
  setDescription(value) {
    this.description = value;
  }

  @action
  setEditableRoot(value) {
    this.editableRoot = value;
  }

  @action
  setName(value) {
    this.name = value;
  }

  @action
  setPostTemplate(value) {
    this.postTemplate = value;
  }

  @action
  setVisibleToLearners(value) {
    this.visibleToLearners = value;
  }

  @action
  setVisibleToParents(value) {
    this.visibleToParents = value;
  }

  Jurisdiction = Jurisdiction;
  PageType = PageType;

  postTemplateProperties = Object.freeze([
    'type',
    'name',
    'description',
    'jurisdictions',
    'postTemplate',
    'editableRoot',
    'visibleToParents',
    'visibleToLearners',
  ]);

  // Props
  type = PageType.STUDENT;

  entity = null;
  isAdminTemplate = false;
  jurisdiction = null;
  fieldGroups = null;
  fieldTemplateSets = null;
  saveInProgress = false;
  onClose() {}
  onPreview() {}
  onSave() {}

  // State
  @tracked editor = null;

  editorOptions = null;

  get editorContainer() {
    if (isEmpty(this.editor)) {
      return;
    }
    return this.editor.getContainer();
  }

  @tracked
  placeholderDialogOpen = false;
  @tracked
  name = '';
  @tracked
  description = '';
  @tracked
  jurisdictions = [];
  @tracked
  postTemplate = '';
  @tracked
  editableRoot = false;
  @tracked
  visibleToParents = false;
  @tracked
  visibleToLearners = false;

  @computed('jurisdictions.[]')
  get selectedJurisdictions() {
    return Jurisdiction.values.filter((jurisdiction) =>
      this.jurisdictions.includes(jurisdiction.value),
    );
  }

  // Lifecycle Hooks
  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    let props = {};
    if (!isEmpty(this.entity)) {
      // Editing an existing entity.  Populate all relevant properties.
      props = this.entity.getProperties(this.postTemplateProperties);
      if (this.isAdminTemplate && props.jurisdictions) {
        // jurisdictions comes back as a real @array('number') fragment on
        // the admin post-template model. Copy it into a plain array here so
        // the rest of the component never has to deal with the fragment
        // type directly.
        props.jurisdictions = props.jurisdictions.toArray();
      }
    } else if (this.isAdminTemplate && !isEmpty(this.jurisdiction)) {
      // This is a new Post Template Template, and the user is filtering for a
      // specific jurisdiction.  Add that jurisdiction by default.
      props.jurisdictions = [parseInt(this.jurisdiction, 10)];
    }
    props.editorOptions = postTemplateTinyMCEConfig(
      (editor) => (this.editor = editor),
      () => (this.placeholderDialogOpen = true),
    );
    this.setProperties(props);
  }

  @action
  closePlaceholderDialog() {
    this.placeholderDialogOpen = false;
  }

  @action
  closeDialog() {
    this.onClose();
  }

  @action
  preview() {
    this.onPreview(this.postTemplate, this.editableRoot);
  }

  @action
  save() {
    let props = this.getProperties(this.postTemplateProperties);
    if (this.isAdminTemplate) {
      props.jurisdictions = [...this.jurisdictions];
    }
    this.onSave(props);
  }

  @action
  addJurisdiction(jurisdiction) {
    this.jurisdictions = [...this.jurisdictions, jurisdiction.value];
  }

  @action
  removeJurisdiction(jurisdiction) {
    this.jurisdictions = this.jurisdictions.filter(
      (value) => value !== jurisdiction.value,
    );
  }

  // Methods
  resetForm() {
    this.name = '';
    this.description = '';
    this.jurisdictions = [];
    this.postTemplate = '';
    this.editableRoot = false;
    this.visibleToParents = false;
    this.visibleToLearners = false;
  }
}
